// @file All GraphQL queries for walls
import gql from 'graphql-tag'

export const DELETE_PADLET: any = gql`
  mutation ($wallId: ID!) {
    deleteWall(id: $wallId) {
      id
    }
  }
`

export const ARCHIVE_PADLET: any = gql`
  mutation ($wallId: ID!) {
    archiveWall(id: $wallId) {
      id
    }
  }
`

export const UNARCHIVE_PADLET: any = gql`
  mutation ($wallId: ID!) {
    unarchiveWall(id: $wallId) {
      id
    }
  }
`

export const WALL_NOTIFICATIONS: any = gql`
  query ($userId: Int!) {
    user(id: $userId) {
      wall_notifications {
        push_notify
        wall_id
      }
    }
  }
`

export const MUTE_PUSH_NOTIFICATIONS: any = gql`
  mutation ($wallId: ID!) {
    mutePushNotifications(wall_id: $wallId) {
      push_notify
      wall_id
    }
  }
`

export const UNMUTE_PUSH_NOTIFICATIONS: any = gql`
  mutation ($wallId: ID!) {
    unmutePushNotifications(wall_id: $wallId) {
      push_notify
      wall_id
    }
  }
`
